export default __webpack_public_path__ + "static/media/nextech-logo.57fbd42f.png";